import React from 'react';
import EqualWidthColumnStaticContent from "../../Widgets/EqualWidthColumnStaticContent/EqualWidthColumnStaticContent";
import { EQUAL_WIDTH_COLUMN_STATIC_CONTENT } from "../../Constants/templateName";
import { equalWidthColumnMetadata } from "../../Constants/buyerIntent";
export var FilterTile = function FilterTile(_ref) {
  var _ref$filterList = _ref.filterList,
    filterList = _ref$filterList === void 0 ? [] : _ref$filterList,
    _ref$parsedData = _ref.parsedData,
    parsedData = _ref$parsedData === void 0 ? [] : _ref$parsedData,
    clickHandler = _ref.clickHandler,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  function onCardClickHandler(event) {
    var index = event.currentTarget.getAttribute('data-index');
    if (index && filterList[parseInt(index, 10)].count > 0) {
      clickHandler(filterList[parseInt(index, 10)]);
    }
  }
  return parsedData && /*#__PURE__*/React.createElement(EqualWidthColumnStaticContent, {
    name: EQUAL_WIDTH_COLUMN_STATIC_CONTENT,
    templateName: EQUAL_WIDTH_COLUMN_STATIC_CONTENT,
    data: parsedData,
    metadata: equalWidthColumnMetadata,
    handleClick: onCardClickHandler,
    showObserver: false,
    classname: className
  }) || null;
};
export default FilterTile;